import React, { useState, useEffect, useRef } from 'react';
import './Home.css';
import mockup1 from '../assets/images/mockup-image1.webp';
import mockup2 from '../assets/images/mockup-image2.webp';
import mockup3 from '../assets/images/mockups/mockup-image3.webp';
import mockup4 from '../assets/images/mockups/mockup-image4.webp';
import mockup5 from '../assets/images/mockups/mockup-image5.webp';
import mockup6 from '../assets/images/mockups/mockup-image6.webp';
import mockup7 from '../assets/images/mockups/mockup-image7.webp';
import mockup8 from '../assets/images/mockups/mockup-image8.webp';
import mockup9 from '../assets/images/mockups/mockup-image9.webp';
import mockup10 from '../assets/images/mockups/mockup-image10.webp';
import mockup11 from '../assets/images/mockups/mockup-image11.webp';
import mockup12 from '../assets/images/mockups/mockup-image12.webp';
import mockup13 from '../assets/images/mockups/mockup-image13.webp';
import heroBg from '../assets/images/hero-image-1.webp';
import tImage1 from '../assets/images/t-image1.webp';
import tImage2 from '../assets/images/t-image2.webp';
import tImage3 from '../assets/images/t-image3.webp';
import tImage4 from '../assets/images/t-image4.webp';
import tImage5 from '../assets/images/t-image5.webp';
import tImage6 from '../assets/images/t-image6.webp';
import tImage7 from '../assets/images/t-image7.webp';
import playBadge from '../assets/images/google-play-badge.webp';
import cherryBlossom from '../assets/images/cherry-blossom.webp';
import ScrollReveal from '../components/ScrollReveal';

import cardImg from '../assets/images/korean-blog/12-1.webp';
import langImg from '../assets/images/korean-blog/korean-language.webp';
import passportImg from '../assets/images/korean-blog/passport.webp';
import koreanLangCardImg from '../assets/images/korean-blog/korean-language-image.webp';

const featureCards = [
  {
    title: 'About Korea',
    desc: 'කොරියන් යාමට සිටින ඔබට කොරියාව පිළිබද ව මුලික කරුණු සියල්ල මෙමගින් ඉදිරිපත් කෙරේ.',
    icon: 'globe',
    color: '#3b82f6'
  },
  {
    title: 'Korean Language',
    desc: 'කොරියන් භාෂාවේ අක්ෂර මාලාව හා බැදුණු සියලුම කරුණු විභාගය ම පමණක් අරමුණු නොකර එදිනෙදා භාවිතා වන කරුණු ද සමගින් මෙය සමන්විත වේ.',
    icon: 'message',
    color: '#0078bf'
  },
  {
    title: 'Alphabet',
    desc: 'කොරියන් භාෂාවේ අක්ෂර පුහුණුව සදහා නිර්මාණය කර ඇති මෙය මගින් හඩ යොදගෙන, අකුරු මත අදිමින් කොරියන් සර් APP එකටම සුවිශේෂී ක්‍රම මගින් පහසුවෙන් අක්ෂර මාලාව පුහුණු විය හැකිය.',
    icon: 'alphabet',
    color: '#8b5cf6'
  },
  {
    title: 'Standard Book',
    desc: 'මෙහිදී ඔබට කොරියානු අභියෝග්‍යතා විභාගයේ ප්‍රශ්න පත්‍රය සදහා සම්මත උපකාරී පොත් කට්ටලය ලබා ගත හැකිය. කොරියන් කඩයිම් විභාගයට අදාළ පාඩම් 60 හි සියලු අන්තර්ගතයන් මෙහිදී සාකච්චා කෙරේ.',
    icon: 'book-open',
    color: '#ec4899'
  },
  {
    title: 'Korean Word Book',
    desc: 'කොරියන් සර් ඇප් එකට ම සුවිශේෂ වූ මෙම පහසුකම ඔබට ඉතා ප්‍රායෝගිකව රුප සටහන් මගින් වචන කියවමින් ලියමින් සහ සවන් දෙමින් ඉතා ඉක්මනින් සියල්ල මතක තබා ගත හැකි ලෙස සකසා ඇත.',
    icon: 'book',
    color: '#10b981'
  },
  {
    title: 'Easy Grammar',
    desc: 'කොරියන් භාෂාවේ ඇති විශේෂ ව්‍යාකරණමය කරුණු සියල්ල මෙහිදී සාකච්චා කෙරේ. කාලානුරුපිව වරනැගෙන ආකාර (අතීත, වර්තමාන, අනාගත) සියල්ලම මැනවින් විග්‍රහ කෙරේ.',
    icon: 'grammar',
    color: '#f59e0b'
  },
  {
    title: 'Game',
    desc: 'භාෂාවක් ඉගෙනීම ඉතා පහසු කටයුත්තක් නොවේ. නමුත් මෙය ඔබට ඉතා සැහැල්ලුවෙන් සිදු කිරීම සදහා විවිධ ක්‍රියාකාරකම් ඇතුලත් ක්‍රීඩා සමගින් භාවිතා කල හැකිය.',
    icon: 'game',
    color: '#f43f5e'
  },
  {
    title: 'Questions 2000 Book',
    desc: 'කොරියන් රජය විසින් සම්මත ලෙස ලබා දෙන ප්‍රශ්න 2000 ඇතුලත් පොත් දෙකෙහි එන කරුණු නිසි ලෙස ගලපමින් ක්‍රමානුකුල ව සැකසු ප්‍රශ්න පත්‍රයට පෙර සුදානම් කිරීමක් මෙමගින් ලබා දේ.',
    icon: 'file-text',
    color: '#06b6d4'
  },
  {
    title: 'Rehearsal Questions',
    desc: 'ප්‍රධාන විභාගය අරමුණු කරගෙන ම අප විසින් සකසන ලද අනුමාන ප්‍රශ්න ඇතුළත් සජීවී විභාගයක අත්දැකීම මෙමගින් ලබා දේ.',
    icon: 'timer',
    color: '#84cc16'
  },
  {
    title: 'Dictionary',
    desc: 'ත්‍රි භාෂිත එනම් සිංහල, කොරියන් හා ඉංග්‍රීසි භාෂාවෙන් සපිරුණු වචන 50000 කට වඩා ප්‍රමාණයක් ඇති මෙම නිතර යාවත්කාලීන වන පොත ඔබට මෙහිදී ලබා ගත හැකිය.',
    icon: 'dictionary',
    color: '#ef4444'
  },
  {
    title: 'Parrot',
    desc: 'නිතර භාවිතා වන කෙටි වාක්‍ය, සංවාද සියල්ල මෙම පහසුකම මගින් නවාකාරයේ අත්දැකීමක් ලබා දෙනවා නොඅනුමානයි.',
    icon: 'parrot',
    color: '#a855f7'
  },
  {
    title: 'Skill Test',
    desc: 'මුලික කොරියන් විභාගයට සාර්ථකව මුහුණ දුන් පසු ඔබ ට ප්‍රායෝගික කුසලතා පරීක්ෂණයකට මුහුණ දීමට සිදු වේ. මේ සදහා ඉතා නිවැරදිව පුහුණු වීමට මෙය හදුන්වා දී ඇත.',
    icon: 'tool',
    color: '#64748b'
  },
  {
    title: 'Korean Sir',
    desc: 'ඕනෑම වෙලාවක ඔබ වෙනුවෙන් සහය දැක්වීම සදහා මෙම සජීවී සහයකයා නිර්මාණය කර ඇත.',
    icon: 'teacher',
    color: '#1e293b'
  },
  {
    title: 'Online Help',
    desc: 'ඔබට ඇතිවන තාක්ෂණික ගැටළු සම්බන්දව අපගේ තාක්ෂණික නිලධාරියෙකුගේ සේවය මෙහිදී ලබා දේ.',
    icon: 'help',
    color: '#475569'
  }
];

const FeatureIcon = ({ name, color }) => {
  let iconClass = "";

  switch (name) {
    case 'globe':
      iconClass = "fa-solid fa-earth-asia";
      break;
    case 'message':
      iconClass = "fa-solid fa-comments";
      break;
    case 'alphabet':
      iconClass = "fa-solid fa-font";
      break;
    case 'book-open':
      iconClass = "fa-solid fa-book-open";
      break;
    case 'book':
      iconClass = "fa-solid fa-book";
      break;
    case 'grammar':
      iconClass = "fa-solid fa-spell-check";
      break;
    case 'game':
      iconClass = "fa-solid fa-gamepad";
      break;
    case 'file-text':
      iconClass = "fa-solid fa-file-invoice";
      break;
    case 'timer':
      iconClass = "fa-solid fa-clock-rotate-left";
      break;
    case 'dictionary':
      iconClass = "fa-solid fa-book-atlas";
      break;
    case 'parrot':
      iconClass = "fa-solid fa-feather-pointed";
      break;
    case 'tool':
      iconClass = "fa-solid fa-screwdriver-wrench";
      break;
    case 'teacher':
      iconClass = "fa-solid fa-chalkboard-user";
      break;
    case 'help':
      iconClass = "fa-solid fa-circle-question";
      break;
    default:
      return null;
  }

  return (
    <i 
      className={`${iconClass} feature-fa-icon`} 
      style={{ color: color || "currentColor", fontSize: "24px", display: "inline-flex", alignItems: "center", justifyContent: "center" }}
    ></i>
  );
};

const Hero = () => (
  <section className="hero-section" lang="si">
    <div className="hero-bg-shapes" aria-hidden="true">
      <div className="shape shape-1"></div>
      <div className="shape shape-2"></div>
      <div className="shape shape-3"></div>
    </div>

    <div className="hero-bg-image" style={{ backgroundImage: `url(${heroBg})` }} aria-hidden="true"></div>

    <div className="hero-container">
      <div className="hero-text-content">
        <h1 className="hero-main-title typing-main-title">
          <TypingTitle text="කොරියන් සර් " accentText="ඉගෙනුම පහසුයි" accentClass="title-accent" hasBr={true} />
        </h1>

        <p className="hero-sub-text typing-main-title">
          <TypingTitle text="කොරියන් සර් යනු කොරියානු රැකියා බලාපොරොත්තුවෙන් සිටින ඔබ ට තනිව ම භාෂා ඉගෙනුම සදහා නිර්මාණය කරන ලද නවීනතම මෘදුකාංගයකි." speed={40} />
        </p>

        <div className="hero-cta-group">
          <a href="https://play.google.com/store/apps/details?id=com.aeonian.koreansirapp&hl=en" target="_blank" rel="noopener noreferrer" className="play-store-badge">
            <img src={playBadge} alt="Get it on Google Play" />
          </a>
        </div>

        <div className="hero-highlights">
          <div className="highlight-item">
            <div className="highlight-check">✓</div>
            <span>සම්පූර්ණයෙන්ම නොමිලේ</span>
          </div>
          <div className="highlight-item">
            <div className="highlight-check">✓</div>
            <span>සිංහල මාධ්‍යයෙන් ඉගැන්වීම්</span>
          </div>
          <div className="highlight-item">
            <div className="highlight-check">✓</div>
            <span>ඕනෑම තැනක සිට ඉගෙන ගත හැක</span>
          </div>
        </div>

        <div className="hero-stats-pill">
          <div className="stat-box">
            <span className="stat-num">50K+</span>
            <span className="stat-lab">Students</span>
          </div>
          <div className="stat-sep"></div>
          <div className="stat-box">
            <span className="stat-num">4.9</span>
            <span className="stat-lab">Rating</span>
          </div>
          <div className="stat-sep"></div>
          <div className="stat-box">
            <span className="stat-num">100+</span>
            <span className="stat-lab">Videos</span>
          </div>
        </div>
      </div>

      <div className="hero-visual-area">
        <div className="glass-mockup-frame">
          <div className="mockup-stack">
            <img src={mockup1} alt="App 1" className="m-left" />
            <img src={mockup2} alt="App 2" className="m-right" />
          </div>

          <div className="floating-rating-card">
            <div className="rating-top">
              <div className="play-icon-mini">
                <i className="fa-brands fa-google-play fa-xl" style={{ color: '#3bccff' }}></i>
              </div>
              <div className="rating-text">
                <span className="r-label">USER RATING</span>
                <span className="r-val">4.9 / 5.0</span>
              </div>
            </div>
            <p className="rating-desc">
              දිනපතා 50,000+ ශිෂ්‍යයන් අප සමග එකතු වී කොරියානු සිහිනය ජය ගනී.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const Features = () => {
  const row1 = featureCards.slice(0, 7);
  const row2 = featureCards.slice(7, 14);

  return (
    <section className="features-section" lang="si">
      <SectionBlossoms image={tImage1} side="right" />
      <div className="features-container">
        <div className="features-header-centered">
          <h2 className="features-main-title">පහසුකම් රාශියක් එකම තැනකින්</h2>
        </div>

        <div className="slideshow-container">
          {/* Row 1: Leftward Slideshow */}
          <div className="slideshow-row left-slideshow">
            <div className="slideshow-track">
              {[...row1, ...row1, ...row1].map((f, i) => (
                <div key={`r1-${i}`} className="feature-modern-card" style={{ '--card-theme': f.color }}>
                  <div className="feature-icon-wrapper" style={{ backgroundColor: `${f.color}15`, color: f.color }}>
                    <span className="feature-icon-inner">
                      <FeatureIcon name={f.icon} color={f.color} />
                    </span>
                  </div>
                  <div className="feature-details">
                    <h3 className="feature-headline">{f.title}</h3>
                    <p className="feature-subtext">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Row 2: Rightward Slideshow */}
          <div className="slideshow-row right-slideshow">
            <div className="slideshow-track">
              {[...row2, ...row2, ...row2].map((f, i) => (
                <div key={`r2-${i}`} className="feature-modern-card" style={{ '--card-theme': f.color }}>
                  <div className="feature-icon-wrapper" style={{ backgroundColor: `${f.color}15`, color: f.color }}>
                    <span className="feature-icon-inner">
                      <FeatureIcon name={f.icon} color={f.color} />
                    </span>
                  </div>
                  <div className="feature-details">
                    <h3 className="feature-headline">{f.title}</h3>
                    <p className="feature-subtext">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const ExperienceSection = () => (
  <section className="experience-section" lang="si">
    <SectionBlossoms image={tImage4} side="left" />
    <div className="exp-container">
      <div className="exp-visual">
        <div className="exp-device-mockup">
          <div className="exp-mockup-pair">
            <img src={mockup1} alt="Digital Teacher Mockup 1" className="exp-mockup" />
            <img src={mockup11} alt="Digital Teacher Mockup 2" className="exp-mockup exp-mockup-secondary" />
          </div>
        </div>
      </div>

      <div className="exp-content timeline-style">
        <h2 className="exp-main-heading typing-main-title">
          <TypingTitle text="ප්‍රථම ඩිජිටල් ගුරුවරයා" />
        </h2>

        <div className="timeline-wrapper">
          <div className="timeline-line"></div>
          
          <div className="timeline-item">
            <div className="timeline-icon-circle" style={{ backgroundColor: '#9c27b0' }}>
              <i className="fa-solid fa-award fa-xl" style={{ color: 'white' }}></i>
            </div>
            <div className="timeline-content-card">
              <h3 className="timeline-title typing-main-title">
                <TypingTitle text="සුවිශිෂ්ට අත්දැකීම්" />
              </h3>
              <p className="timeline-desc">
                වසර ගණනාවක කොරියන් බස පිළිබඳ පර්යේෂණයක පළමු ඩිජිටල් දිගහැරුම ලෙස මෙය දැක්විය හැකිය.
              </p>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-icon-circle" style={{ backgroundColor: '#0288d1' }}>
              <i className="fa-solid fa-bullseye fa-xl" style={{ color: 'white' }}></i>
            </div>
            <div className="timeline-content-card">
              <h3 className="timeline-title typing-main-title">
                <TypingTitle text="ඉලක්කගත බව" />
              </h3>
              <p className="timeline-desc">
                කොරියාවට පිවිසීමට සිටින ඔබ සඳහා ම ඉලක්කගත ප්‍රශ්න හා භාෂා පුහුණුව ඉතා නිවැරදි ව ලබා දීමට අප උත්සහ ගන්නෙමු.
              </p>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-icon-circle" style={{ backgroundColor: '#689f38' }}>
              <i className="fa-solid fa-graduation-cap fa-xl" style={{ color: 'white' }}></i>
            </div>
            <div className="timeline-content-card">
              <h3 className="timeline-title typing-main-title">
                <TypingTitle text="ස්වයං ඉගෙනුම" />
              </h3>
              <p className="timeline-desc">
                ඇප් එක ස්ථාපනයේ සිටම ඔබට ම සියල්ල ඉතා පහසුවෙන් ඉගෙන ගත හැකි ලෙස අප මෙය නිර්මාණය කර ඇත්තෙමු.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const VideoSection = () => (
  <section className="video-section" lang="si">
    <div className="video-container">
      <div className="video-header">
        <h2 className="v-title typing-main-title">
          <TypingTitle text="කොරියාව පිලිබදව සතිපතා පළවන වීඩියෝ නරඹන්න" speed={80} />
        </h2>
      </div>
      <div className="video-wrapper">
        <div className="video-card">
          <iframe
            src="https://www.youtube.com/embed/yAtu4iD0xo4"
            title="Korean Sir YouTube"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>

      <div className="video-carousel-container">
        <div className="video-carousel-track">
          {[
            "https://www.youtube.com/embed/LOIHi9v3AQM",
            "https://www.youtube.com/embed/21W2ic3mBJw",
            "https://www.youtube.com/embed/6MwslTj8IoE"
          ].map((url, index) => (
            <div key={index} className="carousel-item">
              <div className="carousel-video-card">
                <iframe
                  src={url}
                  title={`Video ${index + 1}`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

const specialItems = [
  {
    icon: <i className="fa-solid fa-cog fa-2xl" style={{ color: 'white' }}></i>,
    color: '#9c27b0',
    label: 'භාවිතයේ පහසුව'
  },
  {
    icon: <i className="fa-solid fa-lock fa-2xl" style={{ color: 'white' }}></i>,
    color: '#0288d1',
    label: 'ආරක්ෂිත බව'
  },
  {
    icon: <i className="fa-solid fa-users fa-2xl" style={{ color: 'white' }}></i>,
    color: '#e53935',
    label: 'පරීශීලක සහාය'
  },
  {
    icon: <i className="fa-solid fa-sync fa-2xl" style={{ color: 'white' }}></i>,
    color: '#f57c00',
    label: 'නිතිපතා යාවත්කාලීන වීම'
  }
];

const TypingTitle = ({ text, accentText, accentClass, hasBr, speed = 120 }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [displayedAccent, setDisplayedAccent] = useState('');
  const [isIntersecting, setIsIntersecting] = useState(false);
  const [showCaret, setShowCaret] = useState(true);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsIntersecting(true);
      }
    }, { threshold: 0.1 });

    if (containerRef.current) observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isIntersecting) return;

    let i = 0;
    let accentI = 0;

    const interval = setInterval(() => {
      if (i <= text.length) {
        setDisplayedText(text.slice(0, i));
        i++;
      } else if (accentText && accentI <= accentText.length) {
        setDisplayedAccent(accentText.slice(0, accentI));
        accentI++;
      } else {
        clearInterval(interval);
        setShowCaret(false);
      }
    }, speed);

    return () => {
      clearInterval(interval);
    };
  }, [isIntersecting, text, accentText, speed]);

  const ghost = (
    <>
      {text}
      {accentText && (
        <>
          {hasBr && <br />}
          <span className={accentClass}>{accentText}</span>
        </>
      )}
      {showCaret && <span className="typing-caret">|</span>}
    </>
  );

  return (
    <span ref={containerRef} className="typing-text">
      <span className="typing-ghost" aria-hidden="true">{ghost}</span>
      <span className="typing-layer">
        {displayedText}
        {accentText && (
          <>
            {hasBr && <br />}
            <span className={accentClass}>{displayedAccent}</span>
          </>
        )}
        {showCaret && <span className="typing-caret">|</span>}
      </span>
    </span>
  );
};

const SpecialSection = () => (
  <section className="special-section" lang="si">
    <SectionBlossoms image={tImage2} side="left" />
    <div className="special-container">
      <h2 className="special-title typing-main-title">
        <TypingTitle text="කොරියන් සර් හි සුවිශේෂතා" />
      </h2>
      <div className="special-grid">
        {specialItems.map((item, i) => (
          <div key={i} className="special-card">
            <div className="special-icon-ring" style={{ background: `linear-gradient(135deg, ${item.color}cc, ${item.color})` }}>
              {item.icon}
            </div>
            <p className="special-label">{item.label}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

const BeyondSection = () => (
  <section className="beyond-section" lang="si">
    <SectionBlossoms image={tImage3} side="right" />
    <div className="beyond-container">
      <div className="beyond-content">
        <h2 className="beyond-title typing-main-title">
          <TypingTitle text="සාම්පුදායක ඉගෙනුමෙන් " accentText="ඔබ්බට" accentClass="beyond-accent" />
        </h2>

        <div className="beyond-checklist-card">
          <div className="beyond-checks">
            <div className="beyond-check-item">
              <span className="bcheck"><i className="fa-solid fa-check" style={{ fontSize: '10px' }}></i></span>
              <span>කොරියානු ශබ්ද මාලාව</span>
            </div>
            <div className="beyond-check-item">
              <span className="bcheck"><i className="fa-solid fa-check" style={{ fontSize: '10px' }}></i></span>
              <span>හඩ නිපුණතා වර්ධකය</span>
            </div>
            <div className="beyond-check-item">
              <span className="bcheck"><i className="fa-solid fa-check" style={{ fontSize: '10px' }}></i></span>
              <span>කොරියානු ජන සංස්කෘතික අධ්‍යනය.</span>
            </div>
          </div>
        </div>

        <p className="beyond-desc">
          පන්ති කාමරයක් තුළ ඉගෙන ගත් සම්පුදාය අතිකමණය කළ අප ඔබට මෙම යෙදුම (APP) මගින් නව මානයකට 
          යෙන්නෙමු. ඔබේ ඉගෙනුම් කුසලතාව ඔබට ම විනිශ්චය කරන්නට සුවිශේෂ අවකාශයක් මේ මගින් ලබා දී ඇත.
        </p>
      </div>

      <div className="beyond-visual">
        <div className="beyond-phone-frame">
          <div className="beyond-mockup-pair">
            <img src={mockup9} alt="Korean Sir App Preview 1" className="beyond-mockup" />
            <img src={mockup10} alt="Korean Sir App Preview 2" className="beyond-mockup beyond-mockup-secondary" />
          </div>
        </div>
      </div>
    </div>
  </section>
);

const mockupSlides = [
  mockup1, mockup2, mockup3, mockup4, mockup5, mockup6,
  mockup7, mockup8, mockup9, mockup10, mockup11, mockup12, mockup13
];

function SectionBlossoms({ image = cherryBlossom, side = 'both' }) {
  return (
    <div className="section-blossom-bg" aria-hidden="true">
      {(side === 'left' || side === 'both') && (
        <img src={image} alt="" className="section-blossom section-blossom--left" decoding="async" />
      )}
      {(side === 'right' || side === 'both') && (
        <img src={image} alt="" className="section-blossom section-blossom--right" decoding="async" />
      )}
    </div>
  );
}

const MockupSlideshow = () => (
  <section className="mslide-section" lang="si">
    <SectionBlossoms image={tImage5} side="right" />
    <div className="mslide-header">
      <h2 className="mslide-title typing-main-title">
        <TypingTitle text="කොරියන් සර් ඇප් එකේ දසුන" />
      </h2>
    </div>
    <div className="mslide-track-wrap">
      <div className="mslide-track">
        {[...mockupSlides, ...mockupSlides].map((img, i) => (
          <div key={i} className="mslide-item">
            <div className="mslide-phone">
              <img src={img} alt={`App screen ${i + 1}`} />
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

const DownloadSection = () => (
  <section className="download-section" lang="si">
    <SectionBlossoms image={tImage7} side="right" />
    <div className="download-container">
      <div className="download-content">
        <h2 className="dl-title">ඔබේ ජංගම දුරකථනයට කොරියන් සර් ඇප් එක අදම බාගත කරගන්න</h2>
        <p className="dl-desc">
          ඕනෑම තැනක සිට පහසුවෙන් කොරියන් භාෂාව ඉගෙන ගැනීමට දැන්ම Google Play Store හරහා අපගේ ඇප් එක බාගත කරගන්න. 
          දැනටමත් 10,000 කට අධික සිසුන් පිරිසක් අප සමඟ එක්වී හමාරයි.
        </p>
        <div className="dl-buttons">
          <a href="https://play.google.com/store/apps/details?id=com.aeonian.koreansirapp&hl=en" target="_blank" rel="noopener noreferrer" className="play-store-btn-large">
            <img src={playBadge} alt="Get it on Google Play" />
          </a>
        </div>
      </div>
      <div className="download-visual">
        <div className="dl-mockup-wrapper">
          <div className="dl-hero-stack">
            <img src={mockup2} alt="App Mockup 1" className="dl-mockup dl-m-left" />
            <img src={mockup7} alt="App Mockup 2" className="dl-mockup dl-m-right" />
          </div>
          <div className="dl-bg-glow"></div>
        </div>
      </div>
    </div>
  </section>
);

const NewsSection = () => {
  const articles = [
    {
      img: koreanLangCardImg,
      badge: 'විශේෂ විස්තර',
      category: 'භාෂා දැනුම',
      time: 'දැන් අලුතින්',
      title: 'කොරියානු භාෂාව',
      desc: 'කොරියානු ජාතිකයින් ලිවීමේදීත් කථා කිරීමේදිත් හාවිතา කරන්නේ එකම භාෂාවක් ය. එය ඔවුන්ගේ ජාතික අනන්යතාවය විදහාපාන...',
      articleKey: 'language'
    },
    {
      img: cardImg,
      badge: 'විශේෂ පාඩම්',
      category: 'භාෂා දැනුම',
      time: 'දින 2කට පෙර',
      title: 'කොරියන් ගණිත ක්රම හා ඒකක ක්රම',
      desc: 'කොරියානුවන් ගණිත ක්රම 2ක් භාවිතා කරයි. චීන ගණිත ක්රමය සහ කොරියන් ගණිත ක්රමය පිළිබඳ සම්පූර්ණ විස්තරය...',
      articleKey: 'numbers'
    },
    {
      img: langImg,
      badge: 'හෝඩිය',
      category: 'භාෂා දැනුම',
      time: 'දැන් අලුතින්',
      title: 'කොරියානු අක්ෂර මාලාව',
      desc: 'කොරියානු හෝඩිය හන්ගල් ලෙස හදුන්වනු ලැබේ. ප්රධාන වශයෙන් කොරියානු භාෂාවේ අකුරු 40කි. මූලික ස්වර...',
      articleKey: 'alphabet'
    },
    {
      img: passportImg,
      badge: 'විශේෂ විස්තර',
      category: 'භාෂා දැනුම',
      time: 'දැන් අලුතින්',
      title: 'ගුවන් ගමන් බලපත්‍රය ලබාගැනීම',
      desc: 'ගුවන් ගමන් බලපත්රය යනු කොරියානු විභාගය සඳහා පෙනී සිටින ඔබට නැතිවම බැරි දෙයකි. මෙහිදී ගුවන් ගමන්...',
      articleKey: 'passport'
    }
  ];

  const handleArticleClick = (e, articleKey) => {
    e.preventDefault();
    window.history.pushState({}, '', `/news?article=${articleKey}`);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  return (
    <section className="home-news-section" lang="si">
      <SectionBlossoms image={tImage6} side="left" />
      <div className="home-news-container">
        <div className="home-news-header">
          <h2 className="hn-title typing-main-title">
            <TypingTitle text="නවතම තොරතුරු සහ විශේෂ පාඩම්" />
          </h2>
        </div>

        <div className="home-news-carousel">
          <div className="home-news-track">
            {articles.map((article, i) => (
              <a 
                href={`/news?article=${article.articleKey}`} 
                key={i} 
                onClick={(e) => handleArticleClick(e, article.articleKey)} 
                className="hn-card glass-panel"
              >
                <div className="hn-img-wrapper">
                  <img src={article.img} alt={article.title} className="hn-img" />
                  <div className="hn-badge">{article.badge}</div>
                </div>
                <div className="hn-content">
                  <div className="hn-meta">
                    <span className="hn-category">
                      <i className="fa-solid fa-book-bookmark" style={{ marginRight: '6px', fontSize: '0.85rem' }}></i>
                      {article.category}
                    </span>
                    <span className="hn-dot">•</span>
                    <span className="hn-time">{article.time}</span>
                  </div>
                  <h3 className="hn-card-title">{article.title}</h3>
                  <p className="hn-card-desc">{article.desc}</p>
                  <div className="hn-read-more">
                    <span>ලිපිය කියවන්න</span>
                    <i className="fa-solid fa-arrow-right" style={{ marginLeft: '6px', fontSize: '0.95rem' }}></i>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>

        <div className="home-news-footer">
          <a 
            href="/news" 
            onClick={(e) => {
              e.preventDefault();
              window.history.pushState({}, '', '/news');
              window.dispatchEvent(new PopStateEvent('popstate'));
            }} 
            className="hn-view-all"
          >
            සියලුම ලිපි බලන්න
          </a>
        </div>
      </div>
    </section>
  );
};

export default function Home() {
  return (
    <div className="home-page">
      <div className="home-blossom-bg" aria-hidden="true">
        <img src={cherryBlossom} alt="" className="home-blossom home-blossom--left" decoding="async" />
      </div>
      <div className="home-page-content">
      <ScrollReveal><Hero /></ScrollReveal>
      <ScrollReveal><Features /></ScrollReveal>
      <ScrollReveal><SpecialSection /></ScrollReveal>
      <ScrollReveal><BeyondSection /></ScrollReveal>
      <ScrollReveal><ExperienceSection /></ScrollReveal>
      <ScrollReveal><VideoSection /></ScrollReveal>
      <ScrollReveal><MockupSlideshow /></ScrollReveal>
      <ScrollReveal><NewsSection /></ScrollReveal>
      <ScrollReveal><DownloadSection /></ScrollReveal>
      </div>
    </div>
  );
}
